import { render } from "./StoreSeatType.vue?vue&type=template&id=5a362b05&scoped=true"
import script from "./StoreSeatType.vue?vue&type=script&lang=js"
export * from "./StoreSeatType.vue?vue&type=script&lang=js"

import "./StoreSeatType.vue?vue&type=style&index=0&id=5a362b05&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5a362b05"

export default script